import { ChevronLeft, ChevronRight, Diamond, Move, Trash2 } from "lucide-react";
import { addKf, delKf, kfIndexAt } from "@/lib/layerMotion";

const EASES = [["linear", "Linear"], ["in", "Ease in"], ["out", "Ease out"], ["inout", "In-out"]];

const Btn = ({ onClick, disabled, testId, children, title }) => (
  <button onClick={onClick} disabled={disabled} title={title} data-testid={testId}
    className="flex items-center justify-center gap-1 text-[11px] px-2 py-1 rounded bg-[#0B0C10] border border-[#2A2E3D] text-slate-300 hover:border-[#EC4899] hover:text-white disabled:opacity-30 disabled:pointer-events-none transition-colors">
    {children}
  </button>
);

export const LayerMotionControls = ({ clip, set, lt, onSeek }) => {
  const f = clip.fx, kfs = f.kfs || [];
  const at = kfIndexAt(f, lt);
  const prev = [...kfs].reverse().find((k) => k.t < lt - 0.02), next = kfs.find((k) => k.t > lt + 0.02 && k.t <= clip.len + 0.02);
  const inside = lt >= 0 && lt <= clip.len;
  return (
    <div className="mt-3 rounded-md border border-[#EC4899]/30 bg-[#EC4899]/5 p-2.5" data-testid="layer-motion">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] uppercase font-mono-ui tracking-wider text-[#EC4899] flex items-center gap-1.5"><Move className="w-3 h-3" />Motion path</span>
        <span className="font-mono-ui text-[10px] text-slate-400" data-testid="layer-motion-count">{kfs.length} KEYFRAME{kfs.length === 1 ? "" : "S"}</span>
      </div>
      <div className="grid grid-cols-[auto_1fr_auto_auto] gap-1">
        <Btn onClick={() => onSeek(clip.start + Math.min(prev.t, clip.len - 0.01))} disabled={!prev} testId="layer-kf-prev" title="Previous keyframe"><ChevronLeft className="w-3 h-3" /></Btn>
        <Btn onClick={() => set(addKf(f, +lt.toFixed(3)))} disabled={!inside || at >= 0} testId="layer-kf-add"><Diamond className="w-3 h-3" />Add keyframe</Btn>
        <Btn onClick={() => set(delKf(f, at))} disabled={at < 0} testId="layer-kf-delete" title="Delete keyframe"><Trash2 className="w-3 h-3" /></Btn>
        <Btn onClick={() => onSeek(clip.start + Math.min(next.t, clip.len - 0.01))} disabled={!next} testId="layer-kf-next" title="Next keyframe"><ChevronRight className="w-3 h-3" /></Btn>
      </div>
      {at >= 0 && at < kfs.length - 1 && (
        <div className="mt-2" data-testid="layer-kf-ease">
          <span className="text-[10px] uppercase font-mono-ui tracking-wider text-slate-500">Ease to next keyframe</span>
          <div className="grid grid-cols-4 gap-1 mt-1">
            {EASES.map(([k, l]) => (
              <button key={k} onClick={() => set({ kfs: kfs.map((x, j) => (j === at ? { ...x, ease: k } : x)) })} data-testid={`layer-kf-ease-${k}`}
                className={`text-[10px] py-1 rounded border transition-colors ${(kfs[at].ease || "linear") === k ? "bg-[#EC4899] border-[#EC4899] text-white" : "bg-[#0B0C10] border-[#2A2E3D] text-slate-400 hover:text-white"}`}>{l}</button>
            ))}
          </div>
        </div>
      )}
      <p className="text-[11px] text-slate-400 mt-2">
        {kfs.length ? "Move the playhead and drag the box — a new keyframe is added automatically. The layer follows a smooth curve through every point."
          : "Add a keyframe, move the playhead, then reposition the layer to build a curved flight path."}
      </p>
    </div>
  );
};
